import { Link } from "react-router-dom";
import { ShoppingBag, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

// Placeholder mostrado enquanto a Loja está desligada (admin toggle).
// Não usa o ShopComingSoon como página com rota própria — é injetado como
// substituto de conteúdo em Products/ProductDetail/Cart quando shopEnabled=false.
export default function ShopComingSoon() {
  return (
    <section className="container-cuidar py-20">
      <div className="mx-auto max-w-xl text-center surface p-10 sm:p-14">
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))]">
          <ShoppingBag className="h-8 w-8" />
        </div>
        <div className="mt-4 inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-[hsl(var(--secondary))]">
          <Sparkles className="h-3 w-3" /> Em breve
        </div>
        <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-black leading-tight">
          Loja Solidária em breve
        </h1>
        <p className="mt-4 text-[hsl(var(--muted-foreground))] leading-relaxed">
          Estamos preparando produtos com carinho para você apoiar o Instituto.
          Enquanto isso, você pode continuar apoiando pelas doações — cada
          contribuição sustenta as famílias que acompanhamos.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="btn-pill bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90">
            <Link to="/doacoes" data-testid="shop-soon-doacoes">Ir para doações</Link>
          </Button>
          <Button asChild variant="outline" className="btn-pill">
            <Link to="/" data-testid="shop-soon-home">Voltar ao início</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
